import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import DataTable from '../../common/components/DataTable'
import { AESDecrypt } from '../../../encrypt-util'
import { getSarsCustomHistory } from '../dashboard/actions/instruction';
import { AppDispatch, RootState } from '../template/store';
import { useBackNavigation } from '../../../hooks/BackNavigation';

const SarsCustomDetails = () => {
  const { t } = useTranslation()
  const [tableData, setTableData] = useState<any[]>([]);
  const { blid } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const linerId = useSelector(
    (state: RootState) => state?.navbarTop?.linerId
  );
  const onBack = useBackNavigation();

  const columnConfig = [
    {
      accessor: "container_number",
      Header: t('resource_2:blcontainerNo'),
      width: 250,
      maxWidth: 450,
    },
    {
      accessor: "customs_release_date",
      Header: t('resource_2:sarsCustomsReleaseDate'),
      width: 250,
      maxWidth: 450,
    },
    {
      accessor: "customs_release_status",
      Header: t('resource_2:customsreleasestatus'),
      width: 250,
      maxWidth: 450,
    },
    { accessor: "remarks", Header: t('resource_1:remarks'), width: 250, maxWidth: 450 }
    // ,
    // {
    //   accessor: "created_date",
    //   Header: t('resource_2:sarsCreatedDate'),
    //   width: 250,
    //   maxWidth: 450,
    // },
    // {
    //   accessor: "modified_date",
    //   Header: t('resource_2:sarsModifiedDate'),
    //   width: 250,
    //   maxWidth: 450,
    // },
  ]
  const getTableData = async () => {
    const custom_id_dec = AESDecrypt(blid ?? "");

    try {
      const response = await dispatch(
        getSarsCustomHistory({
          blIdDecrypted: custom_id_dec,
          linerId: linerId ?? undefined,
        })
      ).unwrap();
      setTableData(Array.isArray(response) ? response : []);
    } catch (e) {
      console.error("Error fetching table data:", e);
      setTableData([]);
    }
  };

  useEffect(() => {
    getTableData();
  }, [blid, linerId]);

  return (
    <Card className='h-100 overflow-auto'>
      <Card.Header className='d-flex align-items-center border-bottom sticky-top bg-white'>
        <FontAwesomeIcon
          icon={faArrowAltCircleLeft}
          className='text-warning cursor-pointer fa-lg mb-1 me-1'
          onClick={onBack}
        />
        <h2 className='fs-0 text-primary mb-1'>{'Customs Release Details'}</h2>
      </Card.Header>
      <Card.Body>
        <div className='col-lg-12 mt-2 mb-2 d-flex flex-column'>
          {(tableData?.length ?? 0) > 0 ? (
            <DataTable
              gridName='SARSCUSTOMERDETAILS'
              columns={columnConfig}
              data={tableData ?? []}
              shortPrepend='sarsCustom_'
              perPage={100}
              sortable={true}
              searchable={false}
              showColumnFilter={false}
              selection={false}
              pagination={false}
              seekPagination={false}
              showExport={false}
              localFilter={true}
              uniqueFilterKey='sarsCustomDetails'
              autoHeight={true}
              maxHeight='62vh'
              tableMinHeight={400}
            // staticHiddenCols={['id']}
            />
          ) : (
            ''
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default SarsCustomDetails;